window.$fxhashFeatures = {};
import * as random from "./utils/random";
import { hex2rgba } from "./utils/color";
import { addFeature, FX_Features } from "./utils/features";
import canvasSketch from "canvas-sketch";
import p5 from "p5";

// console.log(fxhash); // the 64 chars hex number fed to your algorithm
// console.log(fxrand()); // deterministic PRNG function, use it instead of Math.random()

// fxrand is a deterministic PRNG function, use it instead of Math.random()
// we set fxrand as new seed for random functions
random.set_seed(fxrand);

const settings = {
  dimensions: [2048, 2048],
  p5: { p5 },
};

canvasSketch(({ p5, width, height }) => {
  addFeature(
    "Background Colour",
    "bgcolour",
    ["Dark", "Light", "Cool", "Hot"],
    [0.4, 0.4, 0, 0],
    ["#250000", "#9e9d90", "#7db9cb", "#f80174"]
  );

  addFeature(
    "Palette",
    "palette",
    [
      1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21,
      22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39,
      40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50,
    ],
    [
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
    ],
    [
      ["#395a4f", "#432330", "#853c43", "#f25c5e", "#ffa566"],
      ["#c75233", "#c78933", "#d6ceaa", "#79b5ac", "#5e2f46"],
      ["#cc5d4c", "#fffec6", "#c7d1af", "#96b49c", "#5b5847"],
      ["#c5f7f0", "#a9c2c9", "#8e8ca3", "#72577c", "#562155"],
      ["#9e9393", "#5c5656", "#dbd3d3", "#c7d1af"],
      ["#d0cf75", "#f8764e", "#da2644", "#90044a", "#440a2a"],
      ["#a8ab9b", "#172a38", "#ec4b5d", "#f48773", "#e0c590"],
      ["#046d8b", "#309292", "#300692"],
      ["#f38a8a", "#55443d", "#440a2a"],
      ["#efffcd", "#dce9be", "#555152", "#2e2633", "#99173c"], //10
      ["#343838", "#005f6b", "#008c9e", "#00b4cc", "#00dffc"],
      ["#413e4a", "#73626e", "#b38184", "#f0b49e", "#f7e4be"],
      ["#fefe23", "#232323", "#6b3000", "#f9d423", "#ede574"],
      ["#99b898", "#fecea8", "#ff847c", "#e84a5f", "#2a363b"],
      ["#655643", "#80bca3", "#f6f7bd", "#e6ac27", "#bf4d28"],
      ["#ffffff", "#000000", "#eaeaea"],
      ["#351330", "#424254", "#64908a", "#e8caa4", "#cc2a41"],
      ["#554236", "#f77825", "#d3ce3d", "#f1efa5", "#60b99a"],
      ["#5d4157", "#838689", "#a8caba", "#cad7b2", "#ebe3aa"],
      ["#8c2318", "#5e8c6a", "#88a65e", "#bfb35a", "#f2c45a"], //20
      ["#fad089", "#ff9c5b", "#f5634a", "#ed303c", "#3b8183"],
      ["#fe4a49", "#0b156b", "#fed766", "#e6e6ea", "#f4f4f8"],
      ["#f8b195", "#f67280", "#c06c84", "#6c5b7b", "#355c7d"],
      ["#d1e751", "#ffffff", "#000000", "#4dbce9", "#26ade4"],
      ["#1b676b", "#519548", "#88c425", "#bef202", "#eafde6"],
      ["#5e412f", "#fcebb6", "#78c0a8", "#f07818", "#f0a830"],
      ["#bcbdac", "#cfbe27", "#f27435", "#f02475", "#3b2d38"],
      ["#452632", "#91204d", "#e4844a", "#e8bf56", "#e2f7ce"],
      ["#eee6ab", "#c5bc8e", "#696758", "#45484b", "#36393b"],
      ["#f0d8a8", "#3d1c00", "#86b8b1", "#f2d694", "#fa2a00"], //30
      ["#2a044a", "#0b2e59", "#0d6759", "#7ab317", "#a0c55f"],
      ["#f04155", "#ff823a", "#404017", "#fff7bd", "#95cfb7"],
      ["#b9d7d9", "#668284", "#2a2829", "#493736", "#7b3b3b"],
      ["#78755e", "#ccc68d", "#eedd99", "#eec290", "#854200"],
      ["#b3cc57", "#ecf081", "#ffbe40", "#ef746f", "#6d2c3d"],
      ["#a3a948", "#edb92e", "#f85931", "#ce1836", "#009989"],
      ["#300030", "#480048", "#601848", "#c04848", "#f07241"],
      ["#67917a", "#170409", "#b8af03", "#ccbf82", "#e33258"],
      ["#fd81dd", "#c4cbb7", "#ebefc9", "#eee0b7", "#362312"],
      ["#e8d5b7", "#0e2430", "#fc3a51", "#f5b349", "#e8d5b9"], //40
      ["#ab526b", "#362721", "#c5ceae", "#f0e2a4", "#f4ebc3"],
      ["#607848", "#333333", "#c0d860", "#f0f0d8", "#604848"],
      ["#4dfffd", "#c8d9bf", "#000000", "#ecdbbc", "#fedcba"],
      ["#a8e6ce", "#dcedc2", "#333333", "#ffaaa6", "#ff8c94"],
      ["#3e4147", "#fffedf", "#dfba69", "#5a2e2e", "#2a2c31"],
      ["#fc354c", "#29221f", "#13747d", "#0abfbc", "#fcf7c5"],
      ["#cc0c39", "#e6781e", "#c8cf02", "#f8fcc1", "#1693a7"],
      ["#1c2130", "#028f76", "#b3e099", "#ffeaad", "#d14334"],
      ["#a7c5bd", "#e5ddcb", "#eb7b59", "#cf4647", "#524656"],
      ["#dad6ca", "#1bb0ce", "#4f8699", "#6a5e72", "#563444"],
    ]
  );

  addFeature(
    "Number of Strokes",
    "strokes",
    ["High", "Low"],
    [0.6, 0.4],
    [29, 23]
  );

  addFeature(
    "Stroke Density",
    "strokeDensity",
    ["High", "Low"],
    [0.3, 0.7],
    [45, 35]
  );

  addFeature(
    "Stroke Width",
    "strokeWidth",
    ["Wide", "Narrow"],
    [0.3, 0.7],
    [0.3, 0.2]
  );

  addFeature(
    "Stroke Length",
    "strokeLength",
    ["Long", "Medium", "Short"],
    [0, 0.5, 0],
    [3, 4, 5]
  );

  // Write the feature to the console
  console.info("FXHash features:");
  console.table(window.$fxhashFeatures);

  /* --- Sketch setup --*/
  const palette = FX_Features["palette"];
  // This sets the number of 'strokes' through the loop to create the artwork
  let strokes = FX_Features["strokes"];

  // 'Grains' are the repeating elements used in the artwork which we place into an array
  let nGrains = strokes;
  let brush = Array(nGrains).fill();
  let brushWidth = 1;
  let brushPosition = 0;
  let brushDirection = "down";
  let brushColor = random.pick(palette);

  // set the background color on the graphics buffer
  p5.background(FX_Features["bgcolour"]);
  p5.rectMode("center");

  // draw the grain (on each pass of the loop)
  const drawGrain = (grain) => {
    p5.push();
    p5.strokeWeight(random.range(1, 3));
    p5.stroke(hex2rgba(brushColor, 0.2));
    p5.fill(hex2rgba(brushColor, grain.color));
    brushDirection == "down"
      ? (p5.translate(grain.vector.x, grain.vector.y),
        p5.translate(grain.position + brushPosition, brushPosition))
      : (p5.translate(grain.vector.y, grain.vector.x),
        p5.translate(brushPosition, grain.position + brushPosition));
    p5.rect(0, 0, grain.diameter, grain.diameter);

    p5.pop();
  };

  const drawGrains = (brush) => brush.forEach((grain) => drawGrain(grain));

  // Fill the Brush array with new grains
  const newGrain = (brush) => {
    brush = brush.map(() => createGrain());
    return brush;
  };

  // create a single Grain add give it a vector and a diameter
  const createGrain = () => {
    let vector = p5.createVector(0, 0);
    let lifespan = random.range(100, 250);
    let diameter = random.range(10, 130);

    return {
      vector,
      diameter,
      lifespan,
    };
  };

  //The color is set on the 'brush' but this is the intensity
  const colorGrains = (brush) => brush.map((grain) => colorGrain(grain));

  const colorGrain = (grain) => {
    let color = random.range(0.1, 0.2);
    return {
      ...grain,
      color: color,
    };
  };

  //set the grains position on the brush
  const positionGrains = (brush) => brush.map((grain) => positionGrain(grain));

  const positionGrain = (grain) => {
    let position = random.range(0, width * brushWidth);

    return {
      ...grain,
      position,
    };
  };

  const positionBrush = () => {
    brushPosition = random.range(0, width * 0.5);
    brushDirection = random.pick(["right", "down"]);
    brushColor = random.pick(palette);
  };

  const moveGrains = (brush) => brush.map((grain) => moveGrain(grain));
  // update the x or y vector to move the brush stoke right or down
  const moveGrain = (grain) => {
    let updatedVector;
    updatedVector = p5.createVector(
      (grain.vector.x += random.range(-5, 5)),
      (grain.vector.y += random.range(2, 20))
    );
    return {
      ...grain,
      vector: updatedVector,
      lifespan: grain.lifespan - random.range(0, FX_Features["strokeLength"]),
    };
  };

  //remove any grains with a lifespan at 0
  const removeOldGrains = (brush) =>
    brush.filter((grain) => grain.lifespan > 0);
  const removeYGrains = (brush) =>
    brush.filter((grain) => grain.vector.y + brushPosition < width);
  const removeXGrains = (brush) =>
    brush.filter((grain) => grain.vector.x + brushPosition < height);

  const refillGrains = (brush) => {
    strokes -= 1; // reduce strokes by one after each refill (could be a function)
    nGrains = FX_Features["strokeDensity"];
    brush = Array(nGrains).fill();
    brush = newGrain(brush);
    return brush;
  };

  //check the number of strokes and do certain things depending on the index
  const checkStrokes = (strokes) => {
    //Refill and repass
    if (strokes > 0) {
      brush = refillGrains(brush);
      brushWidth =
        brushWidth > FX_Features["strokeWidth"] ? brushWidth * 0.5 : 0.9;
    }
    //All Done!
    if (strokes === 0) {
      artworkFinished();
    }
  };

  const artworkFinished = () => {
    p5.noLoop();
    fxpreview();
  };

  //Fill the brush array with new grains
  brush = newGrain(brush);

  return ({ p5 }) => {
    p5.loop();

    brush = colorGrains(brush);
    brush = positionGrains(brush);
    brush = moveGrains(brush);
    brush = removeOldGrains(brush);
    brush = removeYGrains(brush);
    brush = removeXGrains(brush);

    drawGrains(brush);

    if (brush.length === 0) {
      positionBrush();
      checkStrokes(strokes);
    }
  };
}, settings);
